import { useState, useEffect } from 'react';
import { useInterval } from './useInterval';

export const useCountdown = targetDate => {
  const [distance, setDistance] = useState({});
  let interval;
  const updateDistance = () => {
    if (!targetDate) return;
    const countDownDate = targetDate instanceof Date ? targetDate : new Date(targetDate).getTime();
    const now = new Date().getTime();
    const diff = countDownDate - now;
    setDistance({
      days: Math.floor(diff / (1000 * 60 * 60 * 24)),
      hours: Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
      minutes: Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)),
      seconds: Math.floor((diff % (1000 * 60)) / 1000),
      isEnded: diff < 0
    });
    if (distance < 0) clearInterval(interval);
  };
  interval = useInterval(() => updateDistance(), 1000);
  useEffect(() => {
    if (targetDate) updateDistance();
    else setDistance({});
  }, [targetDate]);
  return distance;
};
